import React from 'react';
import { determineLeftNavAppearance } from '@bbkAdminRedux/app/reducers';
import { AuthorizedPaths } from '@bbkAdminRouter/router-paths';
import { cs } from '@bbkAdminUtils/css-utils';
import { type ReactFCC } from '@bbkAdminUtils/utility-types';
import { useLocation } from '@bbkShared/react-router';

import './styles/layout.scss';

export const MainContent: ReactFCC<{ className?: string }> = ({
  children,
  className,
}) => {
  const location = useLocation();
  const showNav = determineLeftNavAppearance(location.pathname);
  const isOnGetStartedGrowthV2Page =
    location.pathname.endsWith(AuthorizedPaths.getStartedGrowthV2) ||
    location.pathname.endsWith(`${AuthorizedPaths.getStartedGrowthV2}/`);
  // TODO: Remove this (main-content--no-scroll and css in layout.scss) once new get started page is fully implemented
  return (
    <div
      className={cs(
        'main-content',
        {
          'full-screen': !showNav,
          'main-content--no-scroll': isOnGetStartedGrowthV2Page,
        },
        className
      )}
      id="main-content"
    >
      {children}
    </div>
  );
};
